import React, { useState } from "react";
import {
  Alert,
  Card,
  Col,
  Row,
  Table,
  Badge,
  Image,
  Modal,
  Button,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ReactFancyBox from "react-fancybox";
const Item = ({
  item,

  moduleConfig,

  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    if (item.allergens?.length > 0) {
      items.push({
        text: "Allergens",
        value: item.allergens.join(", "),
        type: "text",
      });
    }
    if (item.ingredients) {
      items = [
        ...items,
        {
          text: "Ingredients",
          value: item.ingredients,
          type: "text",
        },
      ];
    }

    if (item.sortOrder) {
      items = [
        ...items,
        {
          text: "Sort Order",
          value: item.sortOrder,
          type: "number",
        },
      ];
    }
    if (item.nutritionalInfo) {
      items = [
        ...items,
        {
          text: "Nutritional Info",
          value: item.nutritionalInfo,
          type: "text",
        },
      ];
    }
    return items;
  };
  const [showPrintModal2, setShowPrintModal2] = useState(false);
  const handlePrintClick2 = () => setShowPrintModal2(true);
  const handleClose2 = () => setShowPrintModal2(false);
function extractAllIngredients(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  const ingredients = [];

  doc.querySelectorAll("li").forEach((li) => {
    const text = li.textContent.trim();

    if (/ingredients/i.test(text)) {
      const parts = text.split(":");
      if (parts[1]) {
        ingredients.push(parts[1].trim());
      }
    }
  });

  return ingredients.join(", "); // join all ingredients
}



  const handlePrint2 = () => {
    const modalContent = document.querySelector(".modal-content");

    const printWindow = window.open("", "", "width=800,height=600");

    // Get Bootstrap CSS from your app (if using CDN or imported in index.html)
    const bootstrapCSS = Array.from(
      document.querySelectorAll("link[rel='stylesheet']")
    )
      .map((link) => `<link rel="stylesheet" href="${link.href}">`)
      .join("");

    printWindow.document.write(`
    <html>
      <head>
        <title>Food Details - ${item.date}</title>
        ${bootstrapCSS}
        <style>
          @page { margin: 15mm; }
          body {
            background: #fff;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            margin: 0;
            padding: 15px;
            font-family: Arial;
          }
          .modal-footer { display: none !important; }
          h3, h5 { margin: 0; }
          ul { padding-left: 20px; }
          li { margin-bottom: 4px; }
        </style>
      </head>
      <body>${modalContent.innerHTML}</body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  return (
    <Card className="item mb-2 borderCream">
      {(item.status === "0" || item.status === 0) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.2)",
            width: "100%",
            height: "100%",
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "20px",
            fontWeight: "600",
            backdropFilter: "blur(1px)",
            borderRadius: "inherit",
          }}
        ></div>
      )}
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            <div className="checkboxCol me-2 mt-2"></div>

            <div className="ms-1 me-2 position-relative userIcon">
              <ReactFancyBox
                thumbnail={
                  process.env.REACT_APP_BACKEND_URL + "public/" + item.image
                }
                image={
                  process.env.REACT_APP_BACKEND_URL + "public/" + item.image
                }
                caption={`${item.title}`}
              />
            </div>

            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red">
                {item.title}
              </span>

              <span className="text-custom-4 mt-1 small text-bold">
                {item.foodTime}
              </span>
            </div>
          </div>
        </Card.Title>

        <div
          className="card-tools endColumn mb-1 pt-1"
          style={{ zIndex: 101, position: "relative" }}
        >
          <div>
            {item.hotOrCold && (
              <span
                className={`badge fw-semibold  rounded-pill shadow-sm me-1 px-2 ${
                  item.hotOrCold.toLowerCase() === "hot"
                    ? "bg-custom-3 text-small text-dark"
                    : "bg-primary text-light"
                }`}
              >
                {item.hotOrCold}
              </span>
            )}

            {item.vegOrNonVeg && (
              <span
                className={`badge fw-semibold  rounded-pill shadow-sm me-1  px-2 ${
                  item.vegOrNonVeg.toLowerCase() === "veg"
                    ? "bg-success text-light"
                    : "bg-danger text-light"
                }`}
              >
                {item.vegOrNonVeg}
              </span>
            )}

            <span className="badge badge-light me-1 text-dark">
              Status :{" "}
              <span className="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span>
            {item.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Created Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-eye"></i>
            </Link>
            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
            <span
              title={`Print ${moduleConfig.singleItemTitle}`}
              onClick={(e) => {
                e.stopPropagation();
                handlePrintClick2();
              }}
              className="btn btn-outline-secondary  listingActionIcon"
            >
              <i className="fas fa-print"></i>
            </span>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col md={12} className="mt-1 mb-1">
            <StatsListing items={getItems()} />
          </Col>
        </Row>
        <Row>
          <Col className="">
            {/* {item.description && (
              <Alert className="alert-custom-3 d-flex mb-1  flex-wrap p-1 font-small">
                <strong className="me-1 mt-1 text-custom-1">
                  Description:
                </strong>
                <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                  <span
                    className="font-small text-normal text-custom-1 html"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></span>
                </div>
              </Alert>
            )} */}
          </Col>
        </Row>
      </Card.Body>
      <Modal show={showPrintModal2} onHide={handleClose2} size="lg" centered>
        <Modal.Body>
          {
            <div style={{ padding: "15px" }}>
              {/* Meal Stats & Menu */}
              <Row>
                <Col xl={"auto"} className="mb-2">
                  <h1 className="text-bold fs-3">{item?.title}</h1>
                </Col>

                {/* Date and Day - centered below image */}
                <Col xs={12} className="text-left mb-3">
                  <h3
                    className="fw-bold mb-1 text-left"
                    style={{
                      color: "#000",
                      letterSpacing: "1px",
                      fontSize: "18px",
                      margin: 0,
                    }}
                  >
                    {item.date}{" "}
                    <span
                      className="text-muted mb-2 text-left"
                      style={{
                        color: "#000",
                        letterSpacing: "1px",
                        fontSize: "15px",
                      }}
                    >
                      {item.vegOrNonVeg}, {item.hotOrCold}
                    </span>
                  </h3>
                </Col>

                <Col md={12}>
                  <div className="mb-4 text-left">
                    {/* Meal Title */}

                    <div className="mb-3">
                      <h5
                        className="fw-bold mb-0"
                        style={{
                          color: "#000",
                          borderBottom: "1px dashed #ccc",
                          width: "fit-content",
                          ma: "10px",
                        }}
                      >
                        Allergens:
                      </h5>
                      <span className="text-muted" style={{ fontSize: "16px" }}>
                        {item.allergens.join(", ")}
                      </span>
                    </div>
                    <div className="mb-2">
                      <h5
                        className="fw-bold mb-0"
                        style={{
                          color: "#000",
                          borderBottom: "1px dashed #ccc",
                          width: "fit-content",
                          marginRight: "10px",
                        }}
                      >
                        Ingredients:
                      </h5>
                      {item.foodTime.toLowerCase() === "lunch" ? (
                        <>
                          <span
                            className="text-muted"
                            style={{ fontSize: "16px" }}
                          >
                           
                            {extractAllIngredients(item.description)}
                          </span>
                        </>
                      ) : (
                        <span
                          className="text-muted"
                          style={{ fontSize: "16px" }}
                        >
                          {item.ingredients}
                        </span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          }
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2}>
            Close
          </Button>

          <Button variant="primary" onClick={handlePrint2}>
            Print
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default Item;
